import React, {useState} from 'react';
import './App.css';
import ContactPopup from './Components/ContactPopupComponent';
import 'bootstrap/dist/css/bootstrap.min.css';
import ContactButton from './Components/ContactButtonComponent';


function App({logosrc, maintext, footertext, 
  headertext,
  popovertext,
  popoverheader,
  position, 
  accentcolor, 
  secondarycolor, 
  goodbyetext, 
  startinghour, 
  endinghour, 
  skipweekends,
  phonefield,
  datefield,
  campaignid,
  apiaddress,
  workinghourstext
}) {
  
  const [popupVisible, setPopupVisible] = useState(false);
  
  return (
    <div className="App">    
      <ContactPopup visible={popupVisible}         
        logoSrc={logosrc} 
        toggle={() => setPopupVisible(!popupVisible)}
        mainText={maintext}
        footerText={footertext}
        headerText={headertext}
        accentColor={accentcolor}
        secondaryColor={secondarycolor}
        goodbyeText={goodbyetext}
        startingHour={startinghour}
        endingHour={endinghour}
        skipWeekends={skipweekends === 'true'}
        phoneField={phonefield}
        dateField={datefield}
        campaignId={campaignid}
        apiAddress={apiaddress}
        workingHoursText={workinghourstext}
      ></ContactPopup>
      <ContactButton 
        accentColor={accentcolor}
        secondaryColor={secondarycolor}
        popoverText={popovertext}
        popoverHeader={popoverheader}
        position={position} onClick={() => setPopupVisible(true)}></ContactButton>
    </div>
  );
}

export default App;
